
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {formRules} from "@/utils/formRules";
import { toCamelCase } from "@/utils/misc";
import { mixins } from "vue-class-component";
import DocumentMixin from "@/mixins/DocumentMixin.vue";

@Component({})
export default class UploadKeysCategories extends mixins(DocumentMixin) {

    @Getter private isAdmin: boolean;
    @Getter private isMobile: boolean;

    private stepOne: boolean = false;
    private rules: object = formRules;
    private stepTwo: boolean = false;
    private validEditKeyInfoForm: boolean = false;
    private isSearchingCategories: boolean = false;
    private categories: any[] = [];
    private searchCategory: string = "";
    private keyCategory: any = {
        code: "",
        fr: "",
        en: "",
        de: "",
        pt: "",
    };


    @Watch("keyCategory.en")
    public handlerCode(newVal: string) {
        this.keyCategory.code = toCamelCase(newVal);
    }

    private mounted(): void {
        this.getCategories();
    }

    private changeModale(): void {
        this.stepOne = false;
        this.stepTwo = true;
    }

    private getCategories(): void {
        this.isSearchingCategories = true;
        this.$store.dispatch("categories/getAll")
            .then((res) => {
                this.categories = res.categories;
                this.isSearchingCategories = false;
            });
    }

    private saveCategory(): void {
        this.$store.dispatch("admin/categories/addCategory", {
            category: this.keyCategory,
        }).then(() => {
          this.$store.commit("alerts/displaySuccess", {
                  msg: this.$i18n?.t("alerts.key.categoryCreated"),
              });
          this.stepTwo = false;
        }).catch((error) => {
          this.$store.commit("alerts/displayHttpError", { error });
        });
    }

    get formattedCategoriesValues(): any[] {
        return this.categories.map((category: any) => ({
            text: category.fr,
            value: category.id,
        }));
    }

    private openDialog(): void {
        this.stepOne = true;
    }
}
